import type { RouteObject } from 'react-router-dom';

import {
  authRoutes,
  businessRoutes,
  desktopRoutes,
  docsRoutes,
  educationRoutes,
  errorRoutes,
  pumsemRoutes,
  quotesRoutes,
  rootRoutes,
  subscriptionRoutes,
} from './routes';
import { RouterHydrateFallback } from './RouterHydrateFallback';

/**
 * 최상위 라우트 조합.
 *
 * 책임: 각 routes 파일이 빌드한 RouteObject를 단순히 펼치는 것뿐.
 *       레이아웃·가드·페이지 결정 로직은 각 routes 파일이 소유한다.
 *
 * 새 path prefix (예: '/comp')가 생기면
 *   1. routes/compRoutes.tsx 추가 (자체 layout으로 wrapping)
 *   2. routes/index.ts에서 export
 *   3. 아래 배열에 펼치기
 *
 * 순서 주의: errorRoutes의 `*`는 항상 마지막.
 */
export const mainRoutes: RouteObject[] = [
  {
    // path 없는 루트 — HydrateFallback 을 걸기 위한 껍데기. element 를 두지 않으면
    // 기본 <Outlet /> 이 렌더되므로 기존 레이아웃 구조는 그대로다.
    HydrateFallback: RouterHydrateFallback,
    children: [
      rootRoutes,
      authRoutes,
      desktopRoutes,
      businessRoutes,
      // 도움말은 레이아웃이 둘(마케팅 헤더 / 도움말 전용 헤더)이라 배열이다.
      ...docsRoutes,
      // 품셈해설도 레이아웃이 둘(관리 = 마케팅 헤더 / 열람 = 검색 셸)이라 배열이다.
      ...pumsemRoutes,
      educationRoutes,
      quotesRoutes,
      subscriptionRoutes,
      ...errorRoutes,
    ],
  },
];
